export default __webpack_public_path__ + "static/media/google.2c6d6aab.PNG";